import { t } from 'i18next';
import logo from 'src/assets/images/fiesta.png';
import { SignOutButton } from 'src/shared';
import AppFooter from 'src/core/components/app-footer/AppFooter';

export function AppRedirectView() {
  return (
    <div
      className='flex flex-column align-items-center justify-content-center text-center'
      style={{ minHeight: '100vh', padding: '2rem' }}
    >
      <img src={logo} alt='FIESTA' style={{ width: '180px', marginBottom: '2rem' }} />

      <h1
        className='font-bebas'
        style={{ fontSize: '3rem', color: '#DBF3F7', margin: '0 0 1rem 0' }}
      >
        {t('domains.appRedirect.headline')}
      </h1>

      <p
        style={{
          color: 'rgba(219, 243, 247, 0.75)',
          fontSize: '1.1rem',
          maxWidth: '480px',
          lineHeight: '1.6',
          marginBottom: '2.5rem',
        }}
      >
        {t('domains.appRedirect.subtext')}
      </p>

      <div className='flex flex-row gap-3 flex-wrap justify-content-center'>
        <a href={t('domains.appRedirect.appstore_url')} target='_blank' rel='noreferrer'>
          <img
            src={t('domains.appRedirect.appstore_icon')}
            alt='Download on the App Store'
            style={{ height: '52px' }}
          />
        </a>
        <a href={t('domains.appRedirect.playstore_url')} target='_blank' rel='noreferrer'>
          <img
            src={t('domains.appRedirect.playstore_icon')}
            alt='Get it on Google Play'
            style={{ height: '52px' }}
          />
        </a>
      </div>

      <SignOutButton
        loginType='redirect'
        label={t('domains.programs.views.join.joinView.signOut')}
        className='p-button-text p-button-secondary'
        style={{ marginTop: '2rem', color: 'rgba(219, 243, 247, 0.35)', fontSize: '0.85rem' }}
      />

      <div
        className='flex flex-column align-items-center gap-2'
        style={{ marginTop: '3rem', opacity: 0.45 }}
      >
        <AppFooter showLogo={false} />
      </div>
    </div>
  );
}

export default AppRedirectView;
